var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 32x32"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Photo",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "fillColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.1091 17.6823C19.7237 16.9154 20.7451 15.1408 20.7451 12.8511C20.7451 9.76098 18.878 7.6001 16.2035 7.6001C13.5291 7.6001 11.6619 9.76098 11.6619 12.8511C11.6619 15.1352 12.6834 16.9042 14.2924 17.6767C10.8547 18.0014 8.80078 19.4066 8.80078 23.8347C8.80078 23.9832 8.85864 24.1255 8.96163 24.2305C9.06462 24.3355 9.2043 24.3945 9.34995 24.3945C9.49559 24.3945 9.63528 24.3355 9.73826 24.2305C9.84125 24.1255 9.89911 23.9832 9.89911 23.8347C9.89911 19.9608 11.4313 18.7124 16.2145 18.7124C20.9977 18.7124 22.5024 20.0112 22.5024 23.8403C22.5024 23.9888 22.5603 24.1311 22.6633 24.2361C22.7663 24.3411 22.906 24.4001 23.0516 24.4001C23.1973 24.4001 23.3369 24.3411 23.4399 24.2361C23.5429 24.1311 23.6008 23.9888 23.6008 23.8403C23.6008 19.4457 21.459 18.0182 18.1091 17.6823ZM12.7603 12.8511C12.7603 10.7966 13.8256 8.71972 16.2035 8.71972C18.5814 8.71972 19.6468 10.7966 19.6468 12.8511C19.6468 14.9057 18.5814 16.9826 16.2035 16.9826C13.8256 16.9826 12.7438 14.9113 12.7438 12.8567L12.7603 12.8511Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountCircle);
export default __webpack_public_path__ + "static/media/account_circle.43c4a311ec5a133c4eabc4e2adea13f4.svg";
export { ForwardRef as ReactComponent };